import { Step } from './WizardMultistepTypes';

export function stepIsCompletedOrSkipped(step: Step | null): step is Step {
    if (!step) {
        return false;
    }
    return step.completed || (step.skippable && step.skipped);
}
